import { useState, useEffect } from 'react';
import AdminSidebar from '@/components/layout/AdminSidebar';
import HarnessTopbar from './HarnessTopbar';

/**
 * HarnessAdminLayout - Admin dashboard layout for UI Harness
 * 
 * IMPORTANT: This is ONLY for /__ui-harness/admin routes
 * Identical to AdminLayout but without Clerk dependencies
 * 
 * DOES NOT:
 * - Use Clerk components
 * - Make API calls
 * - Handle authentication
 */
export default function HarnessAdminLayout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Close sidebar on route change (mobile)
  useEffect(() => {
    setSidebarOpen(false);
  }, [window.location.pathname]);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Admin Sidebar (purple accent) */}
      <AdminSidebar 
        isOpen={sidebarOpen} 
        onClose={() => setSidebarOpen(false)}
      />

      {/* Main content area */}
      <div className="lg:pl-64">
        {/* Harness Topbar (No Clerk) */}
        <HarnessTopbar 
          variant="admin"
          onMenuClick={() => setSidebarOpen(true)} 
        />
        
        {/* Page content */}
        <main className="pt-16">
          {children}
        </main>
      </div>
    </div>
  );
}
